import React, { Component } from "react";
import { Modal } from 'antd';
import { ajax, unparam } from "utils/common";
import VideoHeader from "components/videoHeader";
import VideoFooter from "components/videoFooter";
import VideoModel from "components/videoModel";
import videoHome from "images/video-home.png";
import videoYuan from "images/video-true.png";
import videoSubmit from "images/submit.png";
import Star from "images/icon-star.png";
import StarFill from "images/icon-star-fill.png";
import Evaluate from "images/evaluate.png";
import "./index.less";
// 国际化
import i18nZh_cn from "utils/zh_cn";
import i18nEn_us from "utils/en_us";

class App extends Component{
    state = {
        corpName: localStorage.corpName,
        score: 0,
        tempScore: 0,
        evaluateText: "",
        tagItems: [{
            value: "1",
            name: "体验好",
            checked: false
        }, {
            value: "2",
            name: "网络流畅",
            checked: false
          }, {
            value: "3",
            name: "方便快捷",
            checked: false
        }],
        disabled: true,
        visible: ""
    }
    componentDidMount() {
        //获取页面参数
        const queryString = unparam(location.search);
        // 国际化
        const lang = queryString.lang ? queryString.lang.toLocaleLowerCase() : "zh_cn";
        const i18n = lang === "en_us" ? i18nEn_us : i18nZh_cn;
        let tagItems = this.state.tagItems;
        tagItems.map((item, index) => item.name = i18n.evaluate["tag" + (index +1)]);
        console.log(lang, i18n, tagItems)
        this.setState({
            visible: queryString.evaluate?true:false,
            i18n,
            tagItems
        })
    }
    //评分点击事件
    handleScoreClick = (score) => {
        this.setState({
            score,
            tempScore: score
        }, () => {
            this.validation();
        })
    }
    //评分鼠标移入事件
    handleScoreMouseEnter = (score) => {
        this.setState({
            score
        })
    }
    //评分鼠标移出事件
    handleScoreMouseLeave = () => {
        this.setState({
            score: this.state.tempScore
        })
    }
    //标签点选
    handleTagClick = (index) => {
        const tagItems = this.state.tagItems;
        const tagItem = tagItems[index];
        tagItems[index].checked = !tagItem.checked;
        this.setState({
            tagItems
        }, () => {
            this.validation();
        })
    }
    //textarea事件
    handleTextareaChange = (e) => {
        this.setState({
            evaluateText: e.target.value
        })
    }
    //提交评价
    submitEvaluate = () => {
        const { score, evaluateText, disabled } = this.state;
        if(disabled){
            return false;
        }
        const tagValues = this.getTagValues();
        ajax({
            url: "/evaluate/add",
            method: "post",
            data: {
                grade: score,
                evaluateOptions: tagValues,
                evaluateContent: evaluateText
            }
        }).then(res => {
            this.setState({
                visible: true
            })
        })
    }

    //关闭评价弹窗
    hideModel = () => {
        //关闭页面
        history.back();
        window.close();
    }

    //获取标签内容
    getTagValues = () => {
        let values = [];
        this.state.tagItems.map(item => {
            if(item.checked){
                values.push(item.name);
            }
        })
        return values.join();
    }
    //必填校验
    validation = () => {
        // const tagValues = this.getTagValues();
        this.setState({
            disabled: this.state.score === 0//!(this.state.score > 0 && tagValues != "")
        })
    }

    render(){
        const { i18n, score, tagItems, evaluateText, disabled, visible } = this.state;
        
        // 国际化
        if(!i18n) return null;

        return(
            <div className="video-app-wrap video-background-wrap">
                <VideoHeader i18n={i18n} />
                <div className="video-check-nav">
                    <img src={videoHome} />
                    <strong>{i18n.pageTitle.index}</strong>
                    <span> > </span>
                    <strong>{i18n.pageTitle.feedback}</strong>
                </div>
                <div className="video-main-wrap">
                    {typeof visible === "boolean" && visible?null:<div className="video-suggest-content">
                        <div className="video-suggest-contentTop">
                            <img className="video-suggest-contentTop-pic" src={videoSubmit} />
                            <h3>{i18n.finish.title}</h3>
                            <p>{i18n.finish.subtitle1 + this.state.corpName + i18n.finish.subtitle2 + i18n.finish.subtitle3}</p>
                        </div>
                        <div className="video-suggest-contentBottom">
                            <div className="video-suggest-contentBottom-item video-suggest-contentBottom-item1">
                                <span>{i18n.evaluate.scoreTitle}</span>
                                <div className="suggest-score-wrap" onMouseLeave={this.handleScoreMouseLeave}>
                                    {
                                        [1, 2, 3, 4, 5].map((item, index) => {
                                            return (
                                                <img key={index}
                                                    className="suggest-score"
                                                    onClick={() => this.handleScoreClick(item)}
                                                    onMouseEnter={() => this.handleScoreMouseEnter(item)}
                                                    src={index < score ? StarFill : Star} />
                                            )
                                        })
                                    }
                                </div>
                                {score > 0 ? <span className="suggest-score-text">{score + i18n.evaluate.scoreText}</span> : null}
                            </div>
                            <div className="video-suggest-contentBottom-item video-suggest-contentBottom-item2">
                                <span>{i18n.evaluate.tagTitle}</span>
                                <div className="video-suggest-contentBottom-itemOne">
                                    {
                                        tagItems.map((item, index) => {
                                            return (
                                                <span
                                                    key={index}
                                                    onClick={() => this.handleTagClick(index)}
                                                    className={item.checked ? "checked" : ""}
                                                    >{item.name}</span>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            <div className="video-suggest-contentBottom-item video-suggest-contentBottom-item3">
                                <span>{i18n.evaluate.textareaTitle}</span>
                                <textarea value={evaluateText}
                                    onChange={this.handleTextareaChange}
                                    placeholder={i18n.evaluate.placeholder}/>
                            </div>
                        </div>
                        <button className={disabled?"video-suggest-contentBottomBtn-disabled":"video-suggest-contentBottomBtn"}
                            onClick={this.submitEvaluate}>{i18n.evaluate.btnText}</button>
                    </div>}
                </div>
                <VideoModel visible={visible} title={i18n.evaluate.successTitle}>
                    <div className="model-evaluate-wrap">
                        <img className="model-evaluate-img" src={Evaluate} />
                        <p className="model-evaluate-title">{i18n.evaluate.successTitle}!</p>
                        <p className="model-evaluate-content">{i18n.evaluate.successSubtitle}</p>
                        <div className="model-evaluate-btn" onClick={this.hideModel}>{i18n.evaluate.exitText}</div>
                    </div>
                </VideoModel>
                <VideoFooter i18n={i18n} />
            </div>
        )
    }
}

export default App;